import { IWeek } from "../ISections";

export const getActiveWeeks = (weekList: IWeek[] | null | undefined): IWeek[] =>
  (weekList ?? []).filter(week => (week?.status ?? "off") === "on");
